export interface FeedbackOption {
  value: string;
  label: string;
}

export const PURCHASE_INTENT_OPTIONS: FeedbackOption[] = [
  { value: 'cold', label: 'Frío' },
  { value: 'warm', label: 'Tibio' },
  { value: 'hot', label: 'Caliente' },
];

export const OBJECTION_OPTIONS: FeedbackOption[] = [
  { value: 'price', label: 'Precio' },
  { value: 'delivery_date', label: 'Fecha de entrega' },
  { value: 'financing', label: 'Financiamiento' },
  { value: 'location', label: 'Ubicación' },
  { value: 'amenities', label: 'Amenidades' },
  { value: 'design_size', label: 'Diseño o tamaño' },
  { value: 'other', label: 'Otro' },
];

export const PROSPECT_STAGE_OPTIONS: FeedbackOption[] = [
  { value: 'quoting', label: 'Cotizando' },
  { value: 'awaiting_credit', label: 'Esperando aprobación de crédito' },
  { value: 'comparing', label: 'Comparando opciones' },
  { value: 'ready_to_reserve', label: 'Listo para reservar' },
  { value: 'cooled_off', label: 'Se enfrió' },
];

export const optionLabel = (options: FeedbackOption[], value?: string) =>
  options.find((option) => option.value === value)?.label ?? value ?? '—';
